import { Dict } from '../types';

const parts = ['input', 'icon'];

const baseStyleInput = {
  // Forcefully hide the native icon and extend its hit-area
  '&::-webkit-calendar-picker-indicator': {
    width: '2rem',
    position: 'absolute',
    right: '0.4rem',
    cursor: 'pointer',
    height: '80%',
    opacity: 0,
  },
  color: 'slate.400',
  '&[data-has-value]': {
    color: 'slate.900',
  },
};

const baseStyleIcon = {
  color: 'slate.400',
  height: '100%',
};

const sizes = {
  sm: {
    icon: {
      fontSize: '1.25rem', //20px
    },
  },
  md: {
    icon: {
      fontSize: '1.375rem', //22px
    },
  },
  lg: {
    icon: {
      fontSize: '1.5rem', //24px
    },
  },
};

const baseStyle: Dict = {
  icon: baseStyleIcon,
  input: baseStyleInput,
};

const defaultProps = {
  size: 'md',
};

export const DatepickerNative = {
  parts,
  sizes,
  baseStyle,
  defaultProps,
};
